import React, { useEffect } from 'react'

import {
    useCustomNavigate,
    useCustomDispatch
} from '../../hooks';

import { useAuthSelector } from '../../services/selectors/authSelector';
import { LoadingView } from '../../components/common/loader';

import { fetchPharmacistPendingSignatureList } from '../../services/apis/dispense/pharmacistOfPharmacy';
import { useAllSelector } from '../../services/selectors/allSelector';
import { fetchPendingCounsellingCounts } from '../../services/slices/supervisor/pendingCounselling';
import { useSuperVisorSelector } from '../../services/selectors/allSuperVisorSelector';

import SearchBox from '../../components/common/searchBox';

import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';
import * as routeName from '../../routes/routeName';

const PendingAllPharmacistSignsList = () => {

    const navigate = useCustomNavigate()
    const dispatch = useCustomDispatch()

    const { pharmacyId } = useAuthSelector()
    const { pharmacistOfPharmacyListResponse } = useAllSelector()
	const { pendingCounsellingResponse } = useSuperVisorSelector()

    const pharmacistList = pharmacistOfPharmacyListResponse?.pharmacistPendingSignatureList?.data?.data?.pharmacist

	const pendingCounsellingCounts = pendingCounsellingResponse?.counts?.data?.data?.count


    useEffect(() => {
        if (pharmacyId) {
            dispatch(fetchPharmacistPendingSignatureList(pharmacyId))
            dispatch(fetchPendingCounsellingCounts({
				pharmacyId: pharmacyId
			}))
        }
        return () => { }
    }, [pharmacyId, dispatch])

    const bgColors = [
        'bg-gray-100', 'bg-blue-100', 'bg-green-100', 'bg-yellow-100',
        'bg-purple-100', 'bg-pink-100', 'bg-indigo-100',
    ];

    const iconBgColors = [
        'bg-gray-700', 'bg-blue-700', 'bg-green-700', 'bg-yellow-700',
        'bg-purple-700', 'bg-pink-700', 'bg-indigo-700',
    ];

    const handlePharmacistSignCount = (pharmacist) => {
        navigate(`${routeName.pending_pharmacist_signatures}?id=${pharmacist?.id}`)
    }

    return (
        <React.Fragment>
            <div className="app-wrapper flex justify-center">
                <div className="app-screen no-shades w-full h-full overflow-x-hidden ">

                    <div className="relative p-4" >
                        <div className="card bg-white p-4 rounded-lg shadow-sm">
                            <div className="flex items-center justify-between gap-3">
                                <div>
                                    <Common.TopBar pharmacyId={pharmacyId} />
                                </div>
                                <div className='flex items-center justify-center btnnn pt-4' onClick={() => navigate(`${routeName.DASHBOARD_PHARMACY}`)}>
                                    <Icons.HomeIcon />
                                </div>
                            </div>
                        </div>

                        <div className="flex gap-3 mb-3">
                            <SearchBox pharmacyId={pharmacyId} />
                        </div>

                        {pharmacistOfPharmacyListResponse?.pharmacistPendingSignatureList?.loading ?
                            <LoadingView />
                            :
                            pharmacistOfPharmacyListResponse?.pharmacistPendingSignatureList?.error !== null ?
                                <p className='text-center text-red-500'>Oops we got an issue while fetching Data ! Please try again later.</p>
                                :
                                <>
                                    {pharmacistList?.some(pharmacist => pharmacist.pending_sign > 0) ? (
                                        <>
                                            <div className="flex gap-3 mb-3 items-center justify-center text-lg font-medium">
                                                Pending Signatures
                                            </div>
                                            <div className="dashboard-cards-grid grid lg:grid-cols-3 md:grid-cols-3 grid-cols-2 gap-2">

                                                <div className={`card flex lg:items-center  flex-col p-3 rounded-md  bg-gray-100 gap-1 mb-1`} onClick={() => navigate(`${routeName.pending_counselling}`)}>
                                                    <div className={`rounded-md flex bg-gray-700 items-center justify-center`} style={{ width: '40px', height: '40px' }}>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            version="1.1"
                                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                                            width="26"
                                                            height="26"
                                                            x="0"
                                                            y="0"
                                                            viewBox="0 0 128 128"
                                                            style={{ enableBackground: 'new 0 0 512 512' }}
                                                            xmlSpace="preserve"
                                                            className=""
                                                        >
                                                            <g>
                                                                <g fill="#2976aa">
                                                                    <path
                                                                        d="M85.551 97.855C80.538 96.518 63 92.09 63 92.09v-6.969c3-3.008 6.173-11.673 6.173-11.673s.58.848 1.917.347 3.967-4.673 4.134-9.854-3.365-4.509-3.365-4.509.49-9.357.825-12.867c.334-3.51-3.794-10.559-8.587-10.979-9.672-10.777-37.046-6.079-37.046 10.98 0 3.525.834 12.869.834 12.869s-3.51-.668-3.343 4.512c.167 5.181 2.841 9.359 4.178 9.86s1.468-.334 1.468-.334S33 82.164 36 85.172v7.019s-17.177 4.327-22.191 5.664-5.957 7.908-5.957 15.959c0 0 12.148 6.441 41.534 6.441s42.267-6.441 42.267-6.441c-.001-8.051-1.088-14.622-6.102-15.959z"
                                                                        fill="#ffffff"
                                                                        opacity="1"
                                                                        data-original="#2976aa"
                                                                        className=""
                                                                    ></path>
                                                                    <path
                                                                        d="M85.333 6.96c-14.852 0-27.535 7.933-32.617 19.123 1.398.174 2.752.433 4.046.789 4.706-9.341 15.74-15.912 28.571-15.912 17.094 0 31 11.663 31 26 0 5.151-1.805 10.138-5.22 14.419-2.116 2.651-4.769 4.938-7.883 6.792l-.301.18-9.736 8.402 1.869-4.491-6.566.562c-1.054.09-2.117.136-3.163.136-2.078 0-4.138-.193-6.165-.54.048.527.072 1.073.054 1.65a19.974 19.974 0 0 1-.225 2.376c2.057.325 4.169.514 6.336.514a41.31 41.31 0 0 0 3.503-.15L83 80.834l22.278-19.227c3.508-2.089 6.55-4.712 8.962-7.735 3.842-4.816 6.093-10.638 6.093-16.913 0-16.568-15.67-29.999-35-29.999z"
                                                                        fill="#ffffff"
                                                                        opacity="1"
                                                                        data-original="#2976aa"
                                                                        className=""
                                                                    ></path>
                                                                    <path
                                                                        d="M91.016 29 87.45 46.033a7.688 7.688 0 0 0-.198 1.682c0 1.387.643 1.881 2.03 1.881.892 0 1.288-.124 1.585-.273-.248 3.517-2.773 5.114-5.448 5.114-2.972 0-5.3-1.777-5.3-5.937 0-.942.148-2.222.396-3.411L83.884 29zm-2.229-10.161c2.179 0 3.962 1.783 3.962 3.962s-1.783 3.912-3.962 3.912-3.912-1.732-3.912-3.912 1.732-3.962 3.912-3.962z"
                                                                        fill="#ffffff"
                                                                        opacity="1"
                                                                        data-original="#2976aa"
                                                                        className=""
                                                                    ></path>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </div>
                                                    <div className="text-info">
                                                        <h1 className="text-sm font-medium" style={{ fontSize: "12px", fontWeight: '500px' }}>
                                                            Pending Counselling ({pendingCounsellingCounts})
                                                        </h1>
                                                    </div>
                                                </div>

                                                {pharmacistList
                                                    ?.filter(pharmacist => pharmacist.pending_sign > 0)
                                                    ?.map((pharmacist, index) => (
                                                        <div className={`card flex lg:items-center  flex-col p-3 rounded-md ${bgColors[index % bgColors.length]} bg-opacity-50 gap-1 mb-1`} key={index} onClick={() => handlePharmacistSignCount(pharmacist)}>
                                                            <div className={`rounded-md ${iconBgColors[index % iconBgColors.length]} flex items-center justify-center`} style={{ width: '40px', height: '40px' }}>
                                                                <Icons.UserDispenseIcon />
                                                            </div>
                                                            <div className="text-info">
                                                                <h1 className="text-sm font-medium" style={{ fontSize: "12px", fontWeight: '500px' }}>{pharmacist?.name?.charAt(0)?.toUpperCase() + pharmacist?.name.slice(1)} ({pharmacist?.pending_sign})</h1>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="flex gap-3 mb-3 items-center justify-center text-lg font-normal">
                                            No more pending signatures for today.
                                        </div>
                                    )}

                                </>
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default PendingAllPharmacistSignsList